<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VideoSlice} from '@prismicio-types';
    import VideoDefault from './variations/VideoDefault.vue';
    import VideoMultiple from './variations/VideoMultiple.vue';
    import VideoProduct from './variations/VideoProduct.vue';
    import VideoWithShapes from './variations/VideoWithShapes.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<VideoSlice>());

    const variationComponents = {
        default: VideoDefault,
        videoMultiple: VideoMultiple,
        videoWithShapes: VideoWithShapes,
        videoProduct: VideoProduct,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-video {
        &__link {
            display: inline-block;
            margin-top: var(--joy-core-spacing-8);
            padding-bottom: 6px;
            border-bottom: 2px solid var(--joy-color-secondary-30);
            transition: padding var(--joy-transition-duration-default) var(--joy-transition-timing-function);

            &:hover {
                text-decoration: none;
                padding: 0 6px 6px;
            }
        }

        &--hide-in-mobile {
            display: none;

            @include mq.screen_sm(min) {
                display: block;
            }
        }

        &__grid {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: var(--joy-core-spacing-8);
            margin: var(--joy-core-spacing-8) auto 0;

            @include mq.screen_md(min) {
                max-width: 1140px;
                flex-direction: row;

                &--multiple {
                    flex-wrap: wrap;

                    > div:nth-child(1),
                    > div:nth-child(2) {
                        width: calc(50% - var(--joy-core-spacing-4));
                    }
                }
            }
        }
    }
</style>
